import { getFullName } from '@shared/utils/formatName';
import { type ServiceWalkIn } from '../apiHelpers';
import { ServiceStatusSelect } from '../serviceStatus/ServiceStatusSelect';
import styles from './ActiveReservationCard.scss';
import { OccupantCardContent } from './OccupantCardContent';

export interface WalkInCardProps {
  onClick: () => void;
  walkIn: ServiceWalkIn;
  floorPlanName: string;
}

export const SeatedWalkInCard = ({
  onClick,
  walkIn,
  floorPlanName,
}: WalkInCardProps) => {
  const walkInName =
    getFullName(walkIn.firstName, walkIn.lastName) || 'WALK-IN';

  const { server } = walkIn;

  return (
    <article
      aria-label={`walk-in card for ${walkInName}`}
      className={styles.card}
    >
      <ServiceStatusSelect occupant={walkIn} value={walkIn.serviceStatus} />
      <button
        className={styles.button}
        onClick={onClick}
        aria-label="walk-in details"
      >
        <OccupantCardContent
          guestCount={walkIn.guestCount}
          guestName={walkInName}
          tableName={walkIn.seatedTableName}
          server={server}
          time={walkIn.time}
          floorPlanName={floorPlanName}
          lightspeedOrder={walkIn.lightspeedOrder ?? null}
        />
      </button>
    </article>
  );
};
